// Registro do service worker do PWA — habilita "instalar app" no mobile.
// Só roda no navegador (web) e em build de produção:
//  - NUNCA no app Electron (origem app://, é app nativo — não precisa de SW);
//  - NUNCA em dev (evita o SW interferir no HMR do Vite).
// Usa BASE_URL para respeitar deploys em subcaminho.
export function registerPWA(): void {
  if (typeof window === 'undefined') return;

  const isElectron = Boolean((window as unknown as { desktop?: { isElectron?: boolean } }).desktop?.isElectron);
  if (isElectron) return;

  if (!import.meta.env.PROD) return;
  if (!('serviceWorker' in navigator)) return;

  const base = import.meta.env.BASE_URL || '/';

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${base}sw.js`, { scope: base }).catch((err) => {
      console.warn('[pwa] falha ao registrar service worker:', err);
    });
  });
}
